import React from 'react';
import { Facebook, Instagram, Youtube, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-stone-900 to-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-red-700/20 flex items-center justify-center">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                    className="fill-red-500 stroke-red-500"
                    strokeWidth="1.5"
                  />
                </svg>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white font-serif">Jeevan Utsav Retreat</h3>
                <p className="text-xs text-amber-200 uppercase tracking-wider">Destination Weddings • Rishikesh</p>
              </div>
            </div>
            <p className="text-gray-400 mb-4 max-w-md leading-relaxed">
              Creating divine unions with transparent pricing. Experience premium Rishikesh 
              destination weddings at the best prices with complete honesty.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 hover:bg-amber-700 rounded-full flex items-center justify-center transition-colors"
              >
                <Facebook size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 hover:bg-amber-700 rounded-full flex items-center justify-center transition-colors"
              >
                <Instagram size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 hover:bg-amber-700 rounded-full flex items-center justify-center transition-colors"
              >
                <Youtube size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#packages" className="hover:text-amber-400 transition-colors">
                  Wedding Packages
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-amber-400 transition-colors">
                  Our Services
                </a>
              </li>
              <li>
                <a href="#gallery" className="hover:text-amber-400 transition-colors">
                  Gallery
                </a>
              </li>
              <li>
                <a href="#testimonials" className="hover:text-amber-400 transition-colors">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-amber-400 transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Phone size={16} className="flex-shrink-0 mt-1" />
                <div className="flex flex-col space-y-1">
                  <a href="tel:+919873514657" className="hover:text-amber-400 transition-colors text-sm">
                    +91 98735 14657
                  </a>
                  <a href="tel:+919811173781" className="hover:text-amber-400 transition-colors text-sm">
                    +91 98111 73781
                  </a>
                  <a href="tel:+919837272408" className="hover:text-amber-400 transition-colors text-sm">
                    +91 98372 72408
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <Mail size={16} className="flex-shrink-0 mt-1" />
                <a href="mailto:jeevanutsavyoga@gmail.com" className="hover:text-amber-400 transition-colors text-sm">
                  jeevanutsavyoga@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin size={16} className="flex-shrink-0 mt-1" />
                <span className="text-sm">
                  Jeevan Utsav Retreat<br />
                  Ganga Boghpur Talla<br />
                  Chilla Dam Road<br />
                  Uttarakhand
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-500">
              © {currentYear} Jeevan Utsav Retreat. All rights reserved.
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="hover:text-amber-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-amber-400 transition-colors">
                Terms of Service
              </a>
              <a href="#" className="hover:text-amber-400 transition-colors">
                Cancellation Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
